/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import navbar_logo from "assets/logo.png";
import DarkBlueButton from "common/components/StyledButtons/DarkBlueButton/DarkBlueButton";
import GrayButton from "common/components/StyledButtons/GrayButton/GrayButton";
import ContentEditable from "react-contenteditable";
import {
	MailOutlined,
	MenuOutlined,
	QuestionCircleOutlined,
	SettingOutlined,
	SyncOutlined,
	ToTopOutlined,
	UserOutlined
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { rootReducerType } from "redux/combineReducers";
import "./Header.less";
import ProfilePopup from "common/components/ProfilePopup/ProfilePopup";
import { getMenuItems } from "common/utils";
import { useTranslation } from "react-i18next";
import { Menu, Button } from "antd";
import SubHeader from "./components/SubHeader";
import ExportModal from "../ExportModal/ExportModal";
import sanitizeHtml from "sanitize-html";

import { useGetPortalNameQuery, useSavePortalNameMutation } from "services/profileService";
import useWindowDimensions, { decodeJWT } from "common/functions";
import i18n from "i18next";
import { emailToUsername } from "common/utils";
import Notification from "../NotificationMessage/Notification";

import {
	dashboardApi,
	useGetMenuQuery,
} from "services/dashboardService";

type Props = {
	setRefreshButton: () => void;
	shouldRefresh?: boolean;
	setTabProfile: (value: string) => void;
	editButton?: boolean;
};

const setCurrentTab = (setTabIndex: React.Dispatch<React.SetStateAction<string[] | undefined>>) => {

	const path = window.location.pathname;
	if (path.startsWith("/dashboard")) {
		setTabIndex(["1"]);
	}

	// else if(path.startsWith("/stations/"))
	// 	{
	// 		setTabIndex(["2"]);
	// 	}

	else if (path.startsWith("/chargers")) {
		setTabIndex(["2"]);
	}

	else if (path.startsWith("/transactions")) {
		setTabIndex(["3"]);
	}
	else if (path.startsWith("/users")) {
		setTabIndex(["4"]);
	}
	else if (path.startsWith("/pricing")) {
		setTabIndex(["5"]);
	}
	else if (path.startsWith("/fleets")) {
		setTabIndex(["6"]);
	}
	else if (path.startsWith("/analysis")) {
		setTabIndex(["7"]);
	}
	else if (path.startsWith("/team")) {
		setTabIndex(["8"]);
	}
	else {
		setTabIndex(undefined);
	}

};


const Header = ({ setRefreshButton, shouldRefresh, setTabProfile, editButton = false }: Props) => {

	const { isLoggedIn } = useSelector(
		(state: rootReducerType) => state.authenticationReducer
	);

	const dispatch = useDispatch();

	const [params, setParams] = useState({
		userName: emailToUsername(decodeJWT(isLoggedIn).email),
	});

	const location = useLocation();
	const { data: menuData } = useGetMenuQuery(params, { skip: false });

	const [slibarList, setSlibarList] = useState<any[]>([])

	let list: any[] = []

	let listArr = []

	// const menuItemsHeader = [
	// 	{ name: t("header.dashboard"), aliasName: t("header.dashboard"), triggerClick: () => navigate("/dashboard"), key: "1" },
	// 	// {name: t("header.stations"), triggerClick: () => navigate("/stations/"), key: "2"},
	// 	{ name: t("header.chargers"), aliasName: t("header.chargers"), triggerClick: () => navigate("/chargers"), key: "2" },
	// 	{ name: "Sessions", aliasName: "Transactions", triggerClick: () => navigate("/transactions"), key: "3" },
	// 	{ name: t("header.users"), aliasName: t("header.users"), triggerClick: () => navigate("/users"), key: "4" },
	// 	{ name: "Pricing", aliasName: "Pricing", triggerClick: () => navigate("/pricing"), key: "5" },
	// 	{ name: "Fleets", aliasName: "Fleets", triggerClick: () => navigate("/fleets"), key: "6" },
	// 	{ name: "Analysis", aliasName: "Analysis", triggerClick: () => navigate("/analysis"), key: "7" },
	// 	{ name: "team", aliasName: "team", triggerClick: () => navigate("/team"), key: "8" },
	// ];

	useEffect(() => {
		if (menuData) {
			listArr = menuData.map((el) => {
				if (el instanceof Object) {
					let elArr = Object.keys(el)
					return elArr[0]
				} else {
					return el
				}
			})
			list = listArr.map((it: any, idx) => {
				let text = it
				it = {}
				it.name = text
				it.aliasName = text
				it.key = '' + idx
				if (text == 'Dashboard') {
					it.triggerClick = () => navigate("/dashboard")
				} else if (text == 'Chargers') {
					it.triggerClick = () => navigate("/chargers")
				} else if (text == 'Sessions') {
					it.aliasName = "Transactions"
					it.triggerClick = () => navigate("/transactions")
				} else if (text == 'Users') {
					it.triggerClick = () => navigate("/users")
				} else if (text == 'Pricing') {
					it.triggerClick = () => navigate("/pricing")
				} else if (text == 'Fleet') {
					it.name = "Fleet"
					it.aliasName = "fleets"
					it.triggerClick = () => navigate("/fleets")
				} else if (text == "Analysis") {
					it.triggerClick = () => navigate("/analysis")
				} else if (text == 'Team') {
					it.triggerClick = () => navigate("/team")
				} else {
					it.triggerClick = () => navigate("/dashboard")
				}
				return it
			}) as any[]
			setSlibarList(list)
		}
	}, [menuData])

	useEffect(() => {
		dispatch(
			dashboardApi.endpoints.getMenu.initiate(
				{
					userName: "111",
				},
				{ subscribe: false, forceRefetch: true }
			)
		);
	}, [shouldRefresh, dispatch])

	const handleRefetch = () => {
		setRefreshButton();
	};

	const [savePortalName, { isSuccess }] = useSavePortalNameMutation();

	useEffect(() => {
		if (isSuccess)
			Notification({ type: "success", message: i18n.t("profile.toastTitle"), description: i18n.t("profile.toastPortalSave") });
	}, [isSuccess]);

	const sanitizeConf = {
		allowedTags: [],
		allowedAttributes: { a: ["href"] }
	};

	const [isVisibleExportModal, setIsVisibleExportModal] = useState(false);

	const [isVisibleProfilePopup, setIsVisibleProfilePopup] = useState<boolean>(false);
	const [tabIndex, setTabIndex] = useState<string[] | undefined>(["1"]);
	const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

	const navigate = useNavigate();

	const [edit, setEdit] = useState(false);
	const { t } = useTranslation();
	const { PageName } = useSelector((state: rootReducerType) => state.pageNameReducer);
	const { data: title } = useGetPortalNameQuery(decodeJWT(isLoggedIn).email);
	const [tempTitle, setTempTitle] = useState(title);

	if (PageName === "profile") {
		editButton = true
	} else {
		editButton = false
	}


	const handleSupportClick = () => {
		setTabIndex(undefined);
		navigate("/support");
	};

	const handleEditProfileClick = () => {
		setTabProfile("2");
		navigate("/profile");
	};

	useEffect(() => {
		setTempTitle(title)
	}, [title])

	const tabPanelsHeaderButtons = [
		{ name: t("header.refresh"), aliasName: t("header.refresh"), key: "7", icon: <SyncOutlined />, triggerClick: () => null },
		{ name: t("header.export"), aliasName: t("header.export"), key: "8", icon: <ToTopOutlined />, triggerClick: () => setIsVisibleExportModal(true) },
		{ name: t("header.support"), aliasName: t("header.support"), key: "9", icon: <QuestionCircleOutlined />, triggerClick: () => { navigate("/support") } },
		{ name: t("header.email"), aliasName: t("header.email"), key: "10", icon: <MailOutlined />, triggerClick: () => navigate("/profile") },
		{ name: t("header.profile"), aliasName: t("header.profile"), key: "11", icon: <UserOutlined />, triggerClick: () => navigate("/profile") },
	];

	useEffect(() => {
		window.addEventListener("resize", () => setScreenWidth(window.innerWidth));
	}, []);

	useEffect(() => setCurrentTab(setTabIndex), [location]);


	const handleChangeMenuItem = (key: string, menuItems: any[]) => {
		const panelDetails = menuItems.find(item => item.key === key);
		if (panelDetails && panelDetails?.triggerClick) {
			setTabIndex([key] || undefined);
			panelDetails.triggerClick();
		}
	};
	const handleChange = (e) => {
		setTempTitle(sanitizeHtml(e.target.value, sanitizeConf));
	};

	const getDesktopHeader = () => (
		<>
			{/* <Menu
				onClick={(event) => handleChangeMenuItem(event.key, menuItemsHeader)}
				selectedKeys={tabIndex}
				mode='horizontal'
				disabledOverflow={true}
				className='desktopHeader'
			>
				{getMenuItems(menuItemsHeader)}
			</Menu> */}
			<div className="content-editable-title">
				<ContentEditable
					className="editable"
					tagName="pre"
					html={`<div style="font-size: 2vw; font-weight: 800; line-height: 1.1; overflow: hidden; margin-top: 0.5vw">${tempTitle}</div>`}
					disabled={!edit}
					onChange={handleChange}
				/>
				{editButton && (<Button
					className="container-edit-button"
					onClick={() => {
						if (edit) {
							savePortalName({ userName: emailToUsername(decodeJWT(isLoggedIn).email), portalName: tempTitle });
						}
						setEdit(!edit);
					}}
					size="small"
				>
					{edit ? i18n.t("container.save") : i18n.t("container.edit")}
				</Button>)}
			</div>
			<div className='buttons-container'>
				<DarkBlueButton style={{ marginLeft: "auto" }} name={t("header.refresh")} onClick={handleRefetch} />
				<GrayButton icon={<ToTopOutlined />} name={t("header.export")} onClick={() => setIsVisibleExportModal(visible => !visible)} />
				{location.pathname === "/support" ?
					<GrayButton icon={<QuestionCircleOutlined />} style={{ color: "#fbcd3d" }} name={t("header.support")} onClick={handleSupportClick} /> :
					<GrayButton icon={<QuestionCircleOutlined />} name={t("header.support")} onClick={handleSupportClick} />
				}
				<GrayButton icon={<MailOutlined />} className='emailButton' onClick={handleEditProfileClick} />
				<ProfilePopup
					isVisible={isVisibleProfilePopup}
					handleChangeVisibility={(visibility: boolean) =>
						setIsVisibleProfilePopup(visibility)
					}
					setTabIndex={setTabIndex}
					shouldRefresh={shouldRefresh}
					setTabProfile={setTabProfile}
				/>
			</div>
			{isVisibleExportModal ? <ExportModal closeModal={setIsVisibleExportModal} /> : null}
		</>
	);

	const getMobileHeader = () => (
		<>
			<div className='subHeader-container'>
				<ContentEditable
					className="editable"
					tagName="pre"
					html={`<div style="font-size: 3.5vw; font-weight: 800; line-height: 1.1; overflow: hidden; margin-top: 20px">${tempTitle}</div>`}
					disabled={!edit}
					onChange={handleChange}
				/>
				<SubHeader
					icon={MenuOutlined}
					items={slibarList}
					setTabIndex={(key: string[] | undefined) => setTabIndex(key)}
				/>
				<SubHeader icon={SettingOutlined} items={tabPanelsHeaderButtons} />

				<ProfilePopup
					isVisible={isVisibleProfilePopup}
					handleChangeVisibility={(visibility: boolean) =>
						setIsVisibleProfilePopup(visibility)
					}
					setTabIndex={setTabIndex}
					showIcon={false}
					setTabProfile={setTabProfile}
				/>
			</div>
		</>
	);

	const handleClickLogo = () => {
		setTabIndex(["1"]);
		navigate("/dashboard");
	};

	return (
		<>
			{isLoggedIn &&
				<div className='header'>
					{screenWidth > 768 ? getDesktopHeader() : getMobileHeader()}
					{/* <img src={navbar_logo} alt='No logo found' onClick={handleClickLogo}/> */}
				</div>}
			{isVisibleExportModal && screenWidth < 768 ? <ExportModal closeModal={setIsVisibleExportModal} /> : null}
		</>
	);
};

export default Header;
